/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ time: NonNullable<unknown> }} Updated_AtInputs */

const en_updated_at = /** @type {(inputs: Updated_AtInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Updated ${i?.time}`)
};

/**
* | output |
* | --- |
* | "Updated {time}" |
*
* @param {Updated_AtInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const updated_at = /** @type {((inputs: Updated_AtInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Updated_AtInputs, { locale?: "en" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_updated_at(inputs)
});